import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-districtwise-varganidar-subscription-report',
  templateUrl: './districtwise-varganidar-subscription-report.component.html',
  styleUrls: ['./districtwise-varganidar-subscription-report.component.scss'],
})
export class DistrictwiseVarganidarSubscriptionReportComponent
  implements OnInit
{
  isLoading = false;
  startDate = '';
  endDate = '';
  subData;
  districtwiseData = [];
  districtwiseDataTotal = {};
  districtwiseDataTotalTest = {};
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    // { name: 'हिंदुत्व 1', isVisible: false },
    // { name: 'हिंदुत्व 2', isVisible: false },
    // { name: 'आजीव', isVisible: false },
    // { name: 'अनामत', isVisible: false },
  ];
  test = [
    'हितचिंतक सप्रेम भेट',
    'सप्रेम भेट - संपादकीय विभाग',
    'जाहिरात स. भेट',
    'संघ परिवार सप्रेम भेट',
    'वर्गणी सप्रेम भेट',
  ];
  totalth = 0;

  constructor(
    private dialogRef: MatDialogRef<DistrictwiseVarganidarSubscriptionReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  subTypesPerPage = 10;

  ngOnInit(): void {
    this.isLoading = true;
    this.subData = this.data['data'];
    let data = this.uniqueData(this.subData, (a) => a.Subscription_Type);
    // console.log(this.getKey('वार्षिक' + '_पोस्ट'));

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['Subscription_Type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        if (
          data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
          data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
          data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
          data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
          data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        ) {
          this.subTypesName.push({
            name: data[i]['Subscription_Type'],
            isVisible: true,
          });
        }
      }
    }

    this.subTypesName.map((a: any) => {
      let name = this.getKey(a['name']);
      // console.log(name + '_Post');
      this.districtwiseDataTotalTest[name + '_पोस्ट'] = 0;
      this.districtwiseDataTotalTest[name + '_हस्ते'] = 0;
      this.districtwiseDataTotalTest[name + '_मॅगझीन'] = 0;
      this.districtwiseDataTotalTest[name + '_डिजिटल'] = 0;
      this.districtwiseDataTotalTest[name + '_एकूण'] = 0;
    });

    // console.log(this.subTypesName);

    // this.totalth = this.subTypesName.length * 5 + 7;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 5 + 14;

    this.districtwiseDataTotal = {
      ...this.districtwiseDataTotalTest,
      एकूण_पोस्ट: 0,
      एकूण_हस्ते: 0,
      एकूण_मॅगझीन: 0,
      एकूण_डिजिटल: 0,
      एकूण: 0,
    };

    // console.log(this.districtwiseDataTotal);

    this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 7),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    this.setSubData();
  }

  //Old Code Not Show Alphabetical Order
  // setSubData() {
  //   let data = this.uniqueData(this.subData, (a) => a.district);
  //   data.sort((a: any, b: any) => {
  //     return b.district.localeCompare(a.district);
  //   });

  //   for (let i = 0; i < data.length; i++) {
  //     let districtData = this.subData.filter((a) => {
  //       return a.district == data[i]['district'];
  //     });
  //     let subType = this.uniqueData(districtData, (a) => a.Subscription_Type);

  //     for (let j = 0; j < subType.length; j++) {
  //       let subTypeData = districtData.filter((a) => {
  //         return a.Subscription_Type == subType[j]['Subscription_Type'];
  //       });

  //       let post = subTypeData.filter((a) => {
  //         return a.delivery_mode == 'टपाल';
  //       });
  //       // console.log(post);

  //       let haste = subTypeData.filter((a) => {
  //         return a.delivery_mode == 'हस्ते';
  //       });
  //       // console.log(haste);

  //        let magazine = subTypeData.filter((a) => {
  //         return a.delivery_mode == 'मॅगझीन पोस्ट';
  //       });

  //        let digital = subTypeData.filter((a) => {
  //         return a.delivery_mode == 'डिजिटल';
  //       });

  //       this.setSubTypeData(
  //         data[i]['district'],
  //         this.getKey(subType[j]['Subscription_Type']),
  //         post.length,
  //         haste.length,
  //         magazine.length,
  //         digital.length,
  //         j == subType.length - 1 ? true : false
  //       );
  //     }
  //   }
  //   // console.log(this.districtwiseData);

  //   this.calculateTotal();
  // }

  setSubData() {
  let data = this.uniqueData(this.subData, (a) => a.district);

  // ✅ Marathi alphabetical order (A → Z)
  data.sort((a: any, b: any) => {
    return a.district.localeCompare(b.district, 'mr-IN');
  });

  for (let i = 0; i < data.length; i++) {
    let districtData = this.subData.filter((a) => {
      return a.district == data[i]['district'];
    });
    let subType = this.uniqueData(districtData, (a) => a.Subscription_Type);

    for (let j = 0; j < subType.length; j++) {
      let subTypeData = districtData.filter((a) => {
        return a.Subscription_Type == subType[j]['Subscription_Type'];
      });

      let post = subTypeData.filter((a) => a.delivery_mode == 'टपाल');
      let haste = subTypeData.filter((a) => a.delivery_mode == 'हस्ते');
      let magazine = subTypeData.filter((a) => a.delivery_mode == 'मॅगझीन पोस्ट');
      let digital = subTypeData.filter((a) => a.delivery_mode == 'डिजिटल');

      this.setSubTypeData(
        data[i]['district'],
        this.getKey(subType[j]['Subscription_Type']),
        post.length,
        haste.length,
        magazine.length,
        digital.length,
        j == subType.length - 1 ? true : false
      );
    }
  }

  this.calculateTotal();
}


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  setSubTypeData(
    districtName: string,
    subType: string,
    post: number,
    haste: number,
    magazine: number,
    digital: number,
    last: boolean
  ) {
    let foundDistrict = this.districtwiseData.filter((a) => {
      return a.districtName == districtName;
    });

    if (foundDistrict.length == 0) {
      this.subTypesName.map((a: any) => {
        let name = this.getKey(a['name']);
        // this.districtwiseDataTotalTest[name] = 0;
        this.districtwiseDataTotalTest[name + '_पोस्ट'] = 0;
        this.districtwiseDataTotalTest[name + '_हस्ते'] = 0;
        this.districtwiseDataTotalTest[name + '_मॅगझीन'] = 0;
        this.districtwiseDataTotalTest[name + '_डिजिटल'] = 0;
        this.districtwiseDataTotalTest[name + '_एकूण'] = 0;
      });

      this.districtwiseData.push({
        districtName,
        ...this.districtwiseDataTotalTest,
        एकूण_पोस्ट: 0,
        एकूण_हस्ते: 0,
        एकूण_मॅगझीन: 0,
        एकूण_डिजिटल: 0,
        एकूण: 0,
      });
    }

    if (!this.test.includes(subType)) {
      this.setDistrictData(districtName, subType, post, haste, magazine, digital);
    } else {
      this.districtwiseData.map((a) => {
        if (a.districtName == districtName) {
          a[subType + '_पोस्ट'] = post;
          a[subType + '_हस्ते'] = haste;
          a[subType + '_मॅगझीन'] = magazine;
          a[subType + '_डिजिटल'] = digital;
          a[subType + '_एकूण'] = post + haste + magazine + digital;
          a['एकूण_पोस्ट'] += post;
          a['एकूण_हस्ते'] += haste;
          a['एकूण_मॅगझीन'] += magazine;
          a['एकूण_डिजिटल'] += digital;
          a['एकूण'] += post + haste  + magazine + digital;
          return;
        }
      });
    }
  }

  setDistrictData(
    districtName: string,
    subtype: string,
    post: number,
    haste: number,
    magazine: number,
    digital: number
  ) {
    this.districtwiseData.map((a) => {
      if (a.districtName == districtName) {
        a[subtype + '_पोस्ट'] = post;
        a[subtype + '_हस्ते'] = haste;
        a[subtype + '_मॅगझीन'] = magazine;
        a[subtype + '_डिजिटल'] = digital;
        a[subtype + '_एकूण'] = post + haste + magazine + digital;
        a['एकूण_पोस्ट'] += post;
        a['एकूण_हस्ते'] += haste;
        a['एकूण_मॅगझीन'] += magazine;
        a['एकूण_डिजिटल'] += digital;
        a['एकूण'] += post + haste + magazine + digital;
        return;
      }
    });
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  //Old Code show Zero
  // calculateTotal() {
  //   this.districtwiseData.map((a) => {
  //     this.subTypesName.map((b) => {
  //       let key = this.getKey(b.name);
  //       this.districtwiseDataTotal[key + '_पोस्ट'] += a[key + '_पोस्ट'];
  //       this.districtwiseDataTotal[key + '_हस्ते'] += a[key + '_हस्ते'];
  //       this.districtwiseDataTotal[key + '_मॅगझीन'] += a[key + '_मॅगझीन'];
  //       this.districtwiseDataTotal[key + '_डिजिटल'] += a[key + '_डिजिटल'];
  //       this.districtwiseDataTotal[key + '_एकूण'] += a[key + '_एकूण'];
  //     });
  //     this.districtwiseDataTotal['एकूण_पोस्ट'] += a['एकूण_पोस्ट'];
  //     this.districtwiseDataTotal['एकूण_हस्ते'] += a['एकूण_हस्ते'];
  //     this.districtwiseDataTotal['एकूण_मॅगझीन'] += a['एकूण_मॅगझीन'];
  //     this.districtwiseDataTotal['एकूण_डिजिटल'] += a['एकूण_डिजिटल'];
  //     this.districtwiseDataTotal['एकूण'] += a['एकूण'];
  //   });
  //   this.isLoading = false;
  //   // console.log(this.districtwiseDataTotal);
  // }

  calculateTotal() {
  this.districtwiseData.map((a) => {
    this.subTypesName.map((b) => {
      let key = this.getKey(b.name);
      this.districtwiseDataTotal[key + '_पोस्ट'] += a[key + '_पोस्ट'];
      this.districtwiseDataTotal[key + '_हस्ते'] += a[key + '_हस्ते'];
      this.districtwiseDataTotal[key + '_मॅगझीन'] += a[key + '_मॅगझीन'];
      this.districtwiseDataTotal[key + '_डिजिटल'] += a[key + '_डिजिटल'];
      this.districtwiseDataTotal[key + '_एकूण'] += a[key + '_एकूण'];
    });

    this.districtwiseDataTotal['एकूण_पोस्ट'] += a['एकूण_पोस्ट'];
    this.districtwiseDataTotal['एकूण_हस्ते'] += a['एकूण_हस्ते'];
    this.districtwiseDataTotal['एकूण_मॅगझीन'] += a['एकूण_मॅगझीन'];
    this.districtwiseDataTotal['एकूण_डिजिटल'] += a['एकूण_डिजिटल'];
    this.districtwiseDataTotal['एकूण'] += a['एकूण'];
  });

  /* ✅ DISPLAY FIX: convert 0 → blank (district rows) */
  this.districtwiseData.forEach(row => {
    Object.keys(row).forEach(key => {
      if (row[key] === 0) {
        row[key] = '';
      }
    });
  });

  /* ✅ DISPLAY FIX: convert 0 → blank (totals row) */
  Object.keys(this.districtwiseDataTotal).forEach(key => {
    if (this.districtwiseDataTotal[key] === 0) {
      this.districtwiseDataTotal[key] = '';
    }
  });

  this.isLoading = false;
}


  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


 show = false
  // printPage() {
  //   this.show = true
  //   const printContent = document.getElementById('print-section')?.outerHTML;
  //   if (!printContent) {
  //     console.error("Print section not found!");
  //     return;
  //   }

  //   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //            <html>
  //                <head>
  //                    <title>Print Report</title>
  //                    <style>
  //                        @media print {
  //                            @page { 
  //                                size: A3 landscape; /* Set A3 size with landscape mode */
  //                                margin: 5mm; /* Adjust margins */
  //                            }
  //                            body { 
  //                                font-family: Arial, sans-serif; 
  //                                font-size: 15px; /* Adjust font size */
  //                                margin: 0; 
  //                                padding: 5mm; 
  //                                line-height: 1.2; 
  //                            }
  //                            table { 
  //                                width: 100%; 
  //                                height: 100%;
  //                                border-collapse: collapse; 
  //                                table-layout: fixed; /* Prevent column expansion */
  //                                page-break-inside: avoid; /* Avoid breaking the table */
  //                            }
  //                            th, td { 
  //                                padding: 2px; 
  //                                border: 1px solid black; 
  //                                text-align: center; 
  //                                font-size: 12px; /* Adjusted font size */
  //                                line-height: 1.2; 
  //                            }
  //                            .noPrint { 
  //                                display: none; /* Hide print button */
  //                            }
  //                        }
  //                    </style>
  //                </head>
  //                <body>
  //                    <div id="print-section">
  //                        ${printContent}
  //                    </div>
  //                    <script>
  //                        window.onload = function() { 
  //                            window.print(); 
  //                            setTimeout(() => { window.close(); }, 500);
  //                        };
  //                    </script>
  //                </body>
  //            </html>
  //        `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }


//Correct Code
// printPage() {
//   this.show = true;

//   const rows = this.districtwiseData;
//   const totals = this.districtwiseDataTotal;
//   const subTypes = this.subTypesName.filter(s => s.isVisible);

//   const subTypesPerPage = 10;
//   let pagesHTML = '';

//   for (let i = 0; i < subTypes.length; i += subTypesPerPage) {
//     const chunk = subTypes.slice(i, i + subTypesPerPage);
//     const isLastPage = i + subTypesPerPage >= subTypes.length;

//     pagesHTML += `
//     <div class="print-page">
//       <table>
//         <thead>
//           <tr>
//             <th colspan="${2 + chunk.length * 5 + (isLastPage ? 5 : 0)}">
//               दि. ${new Date(this.endDate).toLocaleDateString('en-GB')} च्या अंकाकरिता
//             </th>
//           </tr>

//           <tr>
//             <th rowspan="2">अनु क्र.</th>
//             <th rowspan="2">जिल्हा</th>

//             ${chunk.map(s => `<th colspan="5">${s.name}</th>`).join('')}

//             ${isLastPage ? `<th colspan="5">एकूण</th>` : ``}
//           </tr>

//           <tr>
//             ${chunk.map(() => `
//               <th>पोस्ट</th>
//               <th>हस्ते</th>
//               <th>मॅगझीन</th>
//               <th>डिजिटल</th>
//               <th>एकूण</th>
//             `).join('')}

//             ${isLastPage ? `
//               <th>पोस्ट</th>
//               <th>हस्ते</th>
//               <th>मॅगझीन</th>
//               <th>डिजिटल</th>
//               <th>एकूण</th>
//             ` : ``}
//           </tr>
//         </thead>

//         <tbody>
//           ${rows.map((row, idx) => `
//             <tr>
//               <td>${idx + 1}</td>
//               <td>${row.districtName}</td>

//               ${chunk.map(s => {
//                 const key = this.getKey(s.name);
//                 return `
//                   <td>${row[key + '_पोस्ट'] ?? ''}</td>
//                   <td>${row[key + '_हस्ते'] ?? ''}</td>
//                   <td>${row[key + '_मॅगझीन'] ?? ''}</td>
//                   <td>${row[key + '_डिजिटल'] ?? ''}</td>
//                   <td>${row[key + '_एकूण'] ?? ''}</td>
//                 `;
//               }).join('')}

//               ${isLastPage ? `
//                 <td>${row['एकूण_पोस्ट']}</td>
//                 <td>${row['एकूण_हस्ते']}</td>
//                 <td>${row['एकूण_मॅगझीन']}</td>
//                 <td>${row['एकूण_डिजिटल']}</td>
//                 <td>${row['एकूण']}</td>
//               ` : ``}
//             </tr>
//           `).join('')}

//           ${isLastPage ? `
//           <tr class="total-row">
//             <td colspan="2">एकूण</td>

//             ${chunk.map(s => {
//               const key = this.getKey(s.name);
//               return `
//                 <td>${totals[key + '_पोस्ट']}</td>
//                 <td>${totals[key + '_हस्ते']}</td>
//                 <td>${totals[key + '_मॅगझीन']}</td>
//                 <td>${totals[key + '_डिजिटल']}</td>
//                 <td>${totals[key + '_एकूण']}</td>
//               `;
//             }).join('')}

//             <td>${totals['एकूण_पोस्ट']}</td>
//             <td>${totals['एकूण_हस्ते']}</td>
//             <td>${totals['एकूण_मॅगझीन']}</td>
//             <td>${totals['एकूण_डिजिटल']}</td>
//             <td>${totals['एकूण']}</td>
//           </tr>
//           ` : ``}
//         </tbody>
//       </table>
//     </div>
//     `;
//   }

//   const w = window.open('', '', 'width=2000,height=1200');
//   if (!w) return;

//   w.document.write(`
// <!DOCTYPE html>
// <html>
// <head>
// <title>Print</title>
// <style>
// @page { size: A3 landscape; margin: 8mm; }
// body { font-family: Arial, sans-serif; font-size: 10px; }
// .print-page { page-break-after: always; }
// .print-page:last-child { page-break-after: auto; }
// table { width: 100%; border-collapse: collapse; }
// th, td { border: 1px solid black; padding: 3px; text-align: center; white-space: nowrap; }
// th { background: #f2f2f2; font-weight: bold; }
// </style>
// </head>
// <body>
// ${pagesHTML}
// <script>
// window.onload = () => {
//   window.print();
//   setTimeout(() => window.close(), 1200);
// }
// </script>
// </body>
// </html>
//   `);

//   w.document.close();
// }

//Corrected Code Latest
// printPage() {
//   this.show = true;

//   const rows = this.districtwiseData;
//   const totals = this.districtwiseDataTotal;
//   const subTypes = this.subTypesName.filter(s => s.isVisible);

//   const subTypesPerPage = 10;
//   let pagesHTML = '';

//   for (let i = 0; i < subTypes.length; i += subTypesPerPage) {
//     const chunk = subTypes.slice(i, i + subTypesPerPage);
//     const isLastPage = i + subTypesPerPage >= subTypes.length;

//     pagesHTML += `
//     <div class="print-page">
//       <table>
//         <thead>
//           <tr>
//             <th colspan="${2 + chunk.length * 5 + (isLastPage ? 6 : 0)}">
//               दि. ${new Date(this.endDate).toLocaleDateString('en-GB')} च्या अंकाकरिता
//             </th>
//           </tr>

//           <tr>
//             <th rowspan="2">अनु क्र.</th>
//             <th rowspan="2">जिल्हा</th>

//             ${chunk.map(s => `<th colspan="5">${s.name}</th>`).join('')}

//             ${isLastPage ? `<th colspan="5">एकूण</th><th rowspan="2">जिल्हा</th>` : ``}
//           </tr>

//           <tr>
//             ${chunk.map(() => `
//               <th>पोस्ट</th>
//               <th>हस्ते</th>
//               <th>मॅगझीन</th>
//               <th>डिजिटल</th>
//               <th>एकूण</th>
//             `).join('')}

//             ${isLastPage ? `
//               <th>पोस्ट</th>
//               <th>हस्ते</th>
//               <th>मॅगझीन</th>
//               <th>डिजिटल</th>
//               <th>एकूण</th>
//             ` : ``}
//           </tr>
//         </thead>

//         <tbody>
//           ${rows.map((row, idx) => `
//             <tr>
//               <td>${idx + 1}</td>
//               <td>${row.districtName}</td>

//               ${chunk.map(s => {
//                 const key = this.getKey(s.name);
//                 return `
//                   <td>${row[key + '_पोस्ट'] ?? ''}</td>
//                   <td>${row[key + '_हस्ते'] ?? ''}</td>
//                   <td>${row[key + '_मॅगझीन'] ?? ''}</td>
//                   <td>${row[key + '_डिजिटल'] ?? ''}</td>
//                   <td>${row[key + '_एकूण'] ?? ''}</td>
//                 `;
//               }).join('')}

//               ${isLastPage ? `
//                 <td>${row['एकूण_पोस्ट']}</td>
//                 <td>${row['एकूण_हस्ते']}</td>
//                 <td>${row['एकूण_मॅगझीन']}</td>
//                 <td>${row['एकूण_डिजिटल']}</td>
//                 <td>${row['एकूण']}</td>
//                 <td>${row.districtName}</td>
//               ` : ``}
//             </tr>
//           `).join('')}

//           ${isLastPage ? `
//           <tr class="total-row">
//             <td></td>
//             <td>एकूण</td>

//             ${chunk.map(s => {
//               const key = this.getKey(s.name);
//               return `
//                 <td>${totals[key + '_पोस्ट']}</td>
//                 <td>${totals[key + '_हस्ते']}</td>
//                 <td>${totals[key + '_मॅगझीन']}</td>
//                 <td>${totals[key + '_डिजिटल']}</td>
//                 <td>${totals[key + '_एकूण']}</td>
//               `;
//             }).join('')}

//             <td>${totals['एकूण_पोस्ट']}</td>
//             <td>${totals['एकूण_हस्ते']}</td>
//             <td>${totals['एकूण_मॅगझीन']}</td>
//             <td>${totals['एकूण_डिजिटल']}</td>
//             <td>${totals['एकूण']}</td>
//             <td></td>
//           </tr>
//           ` : ``}
//         </tbody>
//       </table>
//     </div>
//     `;
//   }

//   const w = window.open('', '', 'width=2000,height=1200');
//   if (!w) return;

//   w.document.write(`
// <!DOCTYPE html>
// <html>
// <head>
// <title>Print</title>
// <style>
// @page { size: A3 landscape; margin: 8mm; }
// body { font-family: Arial, sans-serif; font-size: 10px; }
// .print-page { page-break-after: always; }
// .print-page:last-child { page-break-after: auto; }
// table { width: 100%; border-collapse: collapse; }
// thead { display: table-header-group; }
// th, td { border: 1px solid black; padding: 3px; text-align: center; white-space: nowrap; }
// th { background: #f2f2f2; font-weight: bold; }
// </style>
// </head>
// <body>
// ${pagesHTML}
// <script>
// window.onload = () => {
//   window.print();
//   setTimeout(() => window.close(), 1200);
// }
// </script>
// </body>
// </html>
//   `);

//   w.document.close();
// }

//Total Show All Print Page Also show Zero
// printPage() {
//   this.show = true;

//   const rows = this.districtwiseData;
//   const totals = this.districtwiseDataTotal;
//   const subTypes = this.subTypesName.filter(s => s.isVisible);

//   const subTypesPerPage = 10;
//   let pagesHTML = '';

//   for (let i = 0; i < subTypes.length; i += subTypesPerPage) {
//     const chunk = subTypes.slice(i, i + subTypesPerPage);
//     const isLastPage = i + subTypesPerPage >= subTypes.length;

//     pagesHTML += `
//     <div class="print-page">
//       <table>
//         <thead>
//           <tr>
//             <th colspan="${2 + chunk.length * 5 + (isLastPage ? 6 : 0)}">
//               दि. ${new Date(this.endDate).toLocaleDateString('en-GB')} च्या अंकाकरिता
//             </th>
//           </tr>

//           <tr>
//             <th rowspan="2">अनु क्र.</th>
//             <th rowspan="2">जिल्हा</th>

//             ${chunk.map(s => `<th colspan="5">${s.name}</th>`).join('')}

//             ${isLastPage ? `<th colspan="5">एकूण</th><th rowspan="2">जिल्हा</th>` : ``}
//           </tr>

//           <tr>
//             ${chunk.map(() => `
//               <th>पोस्ट</th>
//               <th>हस्ते</th>
//               <th>मॅगझीन</th>
//               <th>डिजिटल</th>
//               <th>एकूण</th>
//             `).join('')}

//             ${isLastPage ? `
//               <th>पोस्ट</th>
//               <th>हस्ते</th>
//               <th>मॅगझीन</th>
//               <th>डिजिटल</th>
//               <th>एकूण</th>
//             ` : ``}
//           </tr>
//         </thead>

//         <tbody>
//           ${rows.map((row, idx) => `
//             <tr>
//               <td>${idx + 1}</td>
//               <td>${row.districtName}</td>

//               ${chunk.map(s => {
//                 const key = this.getKey(s.name);
//                 return `
//                   <td>${row[key + '_पोस्ट'] ?? ''}</td>
//                   <td>${row[key + '_हस्ते'] ?? ''}</td>
//                   <td>${row[key + '_मॅगझीन'] ?? ''}</td>
//                   <td>${row[key + '_डिजिटल'] ?? ''}</td>
//                   <td>${row[key + '_एकूण'] ?? ''}</td>
//                 `;
//               }).join('')}

//               ${isLastPage ? `
//                 <td>${row['एकूण_पोस्ट']}</td>
//                 <td>${row['एकूण_हस्ते']}</td>
//                 <td>${row['एकूण_मॅगझीन']}</td>
//                 <td>${row['एकूण_डिजिटल']}</td>
//                 <td>${row['एकूण']}</td>
//                 <td>${row.districtName}</td>
//               ` : ``}
//             </tr>
//           `).join('')}

//           <!-- ✅ SUBTYPE TOTALS : SHOW ON EVERY PAGE -->
//           <tr class="total-row">
//             <td></td>
//             <td>एकूण</td>

//             ${chunk.map(s => {
//               const key = this.getKey(s.name);
//               return `
//                 <td>${totals[key + '_पोस्ट']}</td>
//                 <td>${totals[key + '_हस्ते']}</td>
//                 <td>${totals[key + '_मॅगझीन']}</td>
//                 <td>${totals[key + '_डिजिटल']}</td>
//                 <td>${totals[key + '_एकूण']}</td>
//               `;
//             }).join('')}

//             ${isLastPage ? `
//               <td>${totals['एकूण_पोस्ट']}</td>
//               <td>${totals['एकूण_हस्ते']}</td>
//               <td>${totals['एकूण_मॅगझीन']}</td>
//               <td>${totals['एकूण_डिजिटल']}</td>
//               <td>${totals['एकूण']}</td>
//               <td></td>
//             ` : ``}
//           </tr>

//         </tbody>
//       </table>
//     </div>
//     `;
//   }

//   const w = window.open('', '', 'width=2000,height=1200');
//   if (!w) return;

//   w.document.write(`
// <!DOCTYPE html>
// <html>
// <head>
// <title>Print</title>
// <style>
// @page { size: A3 landscape; margin: 8mm; }
// body { font-family: Arial, sans-serif; font-size: 10px; }
// .print-page { page-break-after: always; }
// .print-page:last-child { page-break-after: auto; }
// table { width: 100%; border-collapse: collapse; }
// thead { display: table-header-group; }
// th, td { border: 1px solid black; padding: 3px; text-align: center; white-space: nowrap; }
// th { background: #f2f2f2; font-weight: bold; }
// .total-row td { font-weight: bold; }
// </style>
// </head>
// <body>
// ${pagesHTML}
// <script>
// window.onload = () => {
//   window.print();
//   setTimeout(() => window.close(), 1200);
// }
// </script>
// </body>
// </html>
//   `);

//   w.document.close();
// }

//Not Show Zero Only Values Show
printPage() {
  this.show = true;

  const rows = this.districtwiseData;
  const totals = this.districtwiseDataTotal;
  const subTypes = this.subTypesName.filter(s => s.isVisible);

  const subTypesPerPage = 10;
  let pagesHTML = '';

  for (let i = 0; i < subTypes.length; i += subTypesPerPage) {
    const chunk = subTypes.slice(i, i + subTypesPerPage);
    const isLastPage = i + subTypesPerPage >= subTypes.length;

    pagesHTML += `
    <div class="print-page">
      <table>
        <thead>
          <tr>
            <th colspan="${2 + chunk.length * 5 + (isLastPage ? 6 : 0)}">
              दि. ${new Date(this.endDate).toLocaleDateString('en-GB')} च्या अंकाकरिता
            </th>
          </tr>

          <tr>
            <th rowspan="2">अनु क्र.</th>
            <th rowspan="2">जिल्हा</th>
            ${chunk.map(s => `<th colspan="5">${s.name}</th>`).join('')}
            ${isLastPage ? `<th colspan="5">एकूण</th><th rowspan="2">जिल्हा</th>` : ``}
          </tr>

          <tr>
            ${chunk.map(() => `
              <th>पोस्ट</th>
              <th>हस्ते</th>
              <th>मॅगझीन</th>
              <th>डिजिटल</th>
              <th>एकूण</th>
            `).join('')}
            ${isLastPage ? `
              <th>पोस्ट</th>
              <th>हस्ते</th>
              <th>मॅगझीन</th>
              <th>डिजिटल</th>
              <th>एकूण</th>
            ` : ``}
          </tr>
        </thead>

        <tbody>
          ${rows.map((row, idx) => `
            <tr>
              <td>${idx + 1}</td>
              <td>${row.districtName}</td>

              ${chunk.map(s => {
                const key = this.getKey(s.name);
                const val = (k: string) =>
                  row[k] === 0 ? '' : (row[k] ?? '');

                return `
                  <td>${val(key + '_पोस्ट')}</td>
                  <td>${val(key + '_हस्ते')}</td>
                  <td>${val(key + '_मॅगझीन')}</td>
                  <td>${val(key + '_डिजिटल')}</td>
                  <td>${val(key + '_एकूण')}</td>
                `;
              }).join('')}

              ${isLastPage ? `
                <td>${row['एकूण_पोस्ट'] === 0 ? '' : row['एकूण_पोस्ट']}</td>
                <td>${row['एकूण_हस्ते'] === 0 ? '' : row['एकूण_हस्ते']}</td>
                <td>${row['एकूण_मॅगझीन'] === 0 ? '' : row['एकूण_मॅगझीन']}</td>
                <td>${row['एकूण_डिजिटल'] === 0 ? '' : row['एकूण_डिजिटल']}</td>
                <td>${row['एकूण'] === 0 ? '' : row['एकूण']}</td>
                <td>${row.districtName}</td>
              ` : ``}
            </tr>
          `).join('')}

          <tr class="total-row">
            <td></td>
            <td>एकूण</td>

            ${chunk.map(s => {
              const key = this.getKey(s.name);
              const t = (k: string) =>
                totals[k] === 0 ? '' : (totals[k] ?? '');

              return `
                <td>${t(key + '_पोस्ट')}</td>
                <td>${t(key + '_हस्ते')}</td>
                <td>${t(key + '_मॅगझीन')}</td>
                <td>${t(key + '_डिजिटल')}</td>
                <td>${t(key + '_एकूण')}</td>
              `;
            }).join('')}

            ${isLastPage ? `
              <td>${totals['एकूण_पोस्ट'] === 0 ? '' : totals['एकूण_पोस्ट']}</td>
              <td>${totals['एकूण_हस्ते'] === 0 ? '' : totals['एकूण_हस्ते']}</td>
              <td>${totals['एकूण_मॅगझीन'] === 0 ? '' : totals['एकूण_मॅगझीन']}</td>
              <td>${totals['एकूण_डिजिटल'] === 0 ? '' : totals['एकूण_डिजिटल']}</td>
              <td>${totals['एकूण'] === 0 ? '' : totals['एकूण']}</td>
              <td></td>
            ` : ``}
          </tr>

        </tbody>
      </table>
    </div>
    `;
  }

  const w = window.open('', '', 'width=2000,height=1200');
  if (!w) return;

  w.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Print</title>
<style>
@page { size: A3 landscape; margin: 8mm; }
body { font-family: Arial, sans-serif; font-size: 10px; }
.print-page { page-break-after: always; }
.print-page:last-child { page-break-after: auto; }
table { width: 100%; border-collapse: collapse; }
thead { display: table-header-group; }
th, td { border: 1px solid black; padding: 3px; text-align: center; white-space: nowrap; }
th { background: #f2f2f2; font-weight: bold; }
.total-row td { font-weight: bold; }
</style>
</head>
<body>
${pagesHTML}
<script>
window.onload = () => {
  window.print();
  setTimeout(() => window.close(), 1200);
}
</script>
</body>
</html>
  `);

  w.document.close();
}


}
